import styled from '@emotion/styled'

export const StyleInput = styled.input<any>`
  width: 100%;
  border-radius: 6px;
  height: 40px;
  text-indent: 10px;
  padding: 0px;
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : !!props?.isFocus
          ? props.theme.colors.primary
          : props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Lato;
    font-weight: 300;
  }

  ${(props) => props.styleInput}
`

export const StyleIconWrapper = styled.div<any>`
  position: absolute;
  top: 0px;
  right: 0px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`
